import RedeemIcon from "@mui/icons-material/Redeem";
import VouchersList from "./VouchersList";
import VoucherShow from "./VoucherShow";
export const vouchers = {
  list: VouchersList,
  show: VoucherShow,
  icon: RedeemIcon,
  options: { label: "Cadeaux" },
};
